// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Live Inbox – Main Container
   ============================================ */

.live-inbox {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.live-inbox-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
}

/* ============================================
   Empty / Not Enabled State
   ============================================ */

.live-inbox-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background-color: #f9fafb;
  border: 1px dashed #d1d5db;
  border-radius: 14px;
  text-align: center;
}

.live-inbox-empty-icon {
  font-size: 48px;
  color: #9ca3af;
  margin-bottom: 16px;
}

.live-inbox-empty h3 {
  margin: 0 0 8px 0;
  color: #111827;
  font-size: 18px;
  font-weight: 600;
}

.live-inbox-empty p {
  margin: 0 0 24px 0;
  color: #6b7280;
  font-size: 15px;
  max-width: 450px;
}

.live-inbox-setup-btn {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #5616ea;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.live-inbox-setup-btn:hover {
  background-color: #4a14d6;
}

/* ============================================
   Status Bar (Online/Offline toggles)
   ============================================ */

.live-inbox-status-bar {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.live-inbox-bot-status {
  display: flex;
  align-items: center;
  gap: 14px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 14px 20px;
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 1100px;
  box-sizing: border-box;
}

.live-inbox-bot-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.live-inbox-bot-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.live-inbox-bot-desc {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
}

.live-inbox-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  /* Reserve a 1px border slot so disabled / enabled variants share
     identical geometry. The base variants keep it transparent. */
  border: 1px solid transparent;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
}

.live-inbox-toggle.online {
  background-color: #ede9fe;
  color: #5616ea;
}

.live-inbox-toggle.online:hover:not(:disabled):not(.is-disabled) {
  background-color: #ddd6fe;
}

.live-inbox-toggle.offline {
  background-color: #fef2f2;
  color: #dc2626;
}

.live-inbox-toggle.offline:hover:not(:disabled):not(.is-disabled) {
  background-color: #fee2e2;
}

.live-inbox-toggle:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.live-inbox-toggle svg:first-child {
  font-size: 18px;
}

/* ============================================
   Availability section (per bot)
   ============================================ */

.live-inbox-availability {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 16px 20px 14px;
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 1100px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.live-inbox-availability-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
}

.live-inbox-availability-title-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.live-inbox-availability-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

/* Card title treatment shared by the Availability and Notifications
   cards: short purple bar on the left + title text + InfoTooltip on
   the right. Mirrors the .widget-sub-header style used elsewhere. */
.live-inbox-card-title {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #5616ea;
}

.live-inbox-card-title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 18px;
  background-color: #5616ea;
  border-radius: 4px;
  flex-shrink: 0;
}

.live-inbox-availability-desc {
  font-size: 12px;
  color: #9ca3af;
  line-height: 1.4;
}

.live-inbox-availability-count {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: #f3f4f6;
  padding: 4px 8px;
  border-radius: 8px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Spinner shown while the initial agent_status + roster fetches are
   still in flight. Sits in the same slot as the count chip. */
.live-inbox-availability-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #5616ea;
  font-size: 18px;
  flex-shrink: 0;
}

.live-inbox-agent-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* When the "Other agents" group has more than 3 entries, cap the list
   to roughly 3 rows tall and let the rest scroll. Row = ~32px
   (toggle 28px + 4px gap). 3 * 32 = 96px, plus a hairline of breathing
   room so the 4th row is half-visible as a scroll affordance. */
.live-inbox-agent-list.is-scrollable {
  max-height: 108px;
  overflow-y: auto;
  /* Reserve space for the scrollbar so rows don't reflow on hover. */
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.live-inbox-agent-list.is-scrollable::-webkit-scrollbar {
  width: 6px;
}

.live-inbox-agent-list.is-scrollable::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 3px;
}

.live-inbox-agent-list.is-scrollable::-webkit-scrollbar-track {
  background: transparent;
}

.live-inbox-agent-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px;
  font-size: 13px;
  color: #111827;
  border-radius: 8px;
}

.live-inbox-agent-row + .live-inbox-agent-row {
  border-top: 1px solid #f3f4f6;
}

.live-inbox-agent-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: #dc2626;
}

.live-inbox-agent-dot.online {
  background: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.18);
}

.live-inbox-agent-dot.offline {
  background: #dc2626;
  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.18);
}

.live-inbox-agent-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.live-inbox-agent-you {
  color: #9ca3af;
  font-weight: 500;
}

.live-inbox-agent-role {
  font-size: 11px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 1px 6px;
  border-radius: 8px;
  text-transform: capitalize;
  flex-shrink: 0;
}

/* The toggle on a teammate row reuses .live-inbox-toggle. When the
   current user can't act on it, we add .is-disabled. We deliberately
   avoid opacity / grayscale here because they make the pill look
   visually smaller next to its enabled siblings. Instead we keep the
   full-strength background and add a tinted border so the silhouette
   reads as the same size and weight as the interactive variant. */
.live-inbox-toggle.is-disabled {
  cursor: not-allowed;
}

/* Tooltip wrapper around the toggle. Needed because MUI Tooltip can't
   attach pointer listeners to a disabled button directly. The wrap
   should be invisible to layout (inline-flex, no padding/margin). */
.live-inbox-toggle-wrap {
  display: inline-flex;
}

/* Sectioning inside the availability card: "My availability" then a
   strong divider and "Other agents" below. */
.live-inbox-agent-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.live-inbox-agent-section-header {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 2px;
}

.live-inbox-agent-section-divider {
  height: 1px;
  background: #e5e7eb;
  margin: 6px 0 8px;
}

.live-inbox-agent-empty {
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
  padding: 0;
}

.live-inbox-agent-empty-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0;
}

.live-inbox-invite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 20px;
  border: 1px solid transparent;
  background-color: #ede9fe;
  color: #5616ea;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
  white-space: nowrap;
}

.live-inbox-invite-btn:hover {
  background-color: #ddd6fe;
}

.live-inbox-invite-btn svg {
  font-size: 18px;
  /* faUserPlus has a wider glyph than faBell at the same font-size,
     which would otherwise make this pill noticeably wider than the
     Manage Notifications pill. Cap the rendered width so both buttons
     match in size. */
  width: 16px;
}

/* Keep the disabled toggle's background identical to its non-hover state
   and add a tinted border so it carries the same visual weight as an
   interactive pill. Using \`inherit\` for background pulls the row's
   transparent background and visually wipes the pill, so we re-assert
   the per-state colors. */
.live-inbox-toggle.online.is-disabled,
.live-inbox-toggle.online:disabled,
.live-inbox-toggle.online.is-disabled:hover,
.live-inbox-toggle.online:disabled:hover {
  background-color: #ede9fe;
  border-color: #c4b5fd;
  color: #6d28d9;
}

.live-inbox-toggle.offline.is-disabled,
.live-inbox-toggle.offline:disabled,
.live-inbox-toggle.offline.is-disabled:hover,
.live-inbox-toggle.offline:disabled:hover {
  background-color: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

/* ============================================
   No Conversations / Waiting State
   ============================================ */

.live-inbox-no-conversations {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  text-align: center;
  border: 1px solid #e5e7eb;
}

.live-inbox-no-conversations-icon {
  font-size: 40px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.live-inbox-no-conversations h3 {
  margin: 0 0 8px 0;
  color: #111827;
  font-size: 17px;
  font-weight: 600;
}

.live-inbox-no-conversations p {
  margin: 0;
  color: #6b7280;
  font-size: 14px;
  max-width: 420px;
  line-height: 1.5;
}

/* ============================================
   Conversation List
   ============================================ */

/* Conversations card — same chrome (white bg, border, radius, padding,
   width) as the Availability and Notifications cards above, so the
   "Current Conversations" header and its content sit inside one
   container instead of floating on the page background. */
.live-inbox-conversations {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  padding: 16px 20px 14px;
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 1100px;
  box-sizing: border-box;
}

/* "Current Conversations" header inside the card — reuses
   .live-inbox-card-title (purple bar + text) and mirrors the divider
   treatment of .live-inbox-availability-header. */
.live-inbox-conversations-header {
  display: flex;
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 14px;
}

/* Inside the conversations card the empty state and loading spinner are
   already wrapped, so drop their own card chrome to avoid a box-in-box. */
.live-inbox-conversations .live-inbox-no-conversations {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 40px 24px;
}

.live-inbox-conversation-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.live-inbox-conversation-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 18px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  transition: border-color 0.2s;
  cursor: pointer;
}

.live-inbox-conversation-item:focus-visible {
  outline: 2px solid #5616ea;
  outline-offset: 2px;
}

.live-inbox-conversation-item:hover {
  border-color: #d1d5db;
}

.live-inbox-conversation-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 16px;
  flex-shrink: 0;
  position: relative;
}

/* Task 5 — presence dot on avatar */
.live-inbox-conversation-avatar .avatar-presence {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  font-size: 0;
}

.live-inbox-conversation-avatar .avatar-presence.online {
  background-color: #22c55e;
}

.live-inbox-conversation-avatar .avatar-presence.away {
  background-color: #f59e0b;
}

.live-inbox-conversation-avatar .avatar-presence.background {
  background-color: #94a3b8;
}

.live-inbox-conversation-avatar .avatar-presence.offline {
  background-color: #d1d5db;
}

.live-inbox-conversation-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}

.live-inbox-conversation-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  flex-shrink: 0;
  min-width: 50px;
}

.live-inbox-conversation-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Task 3 — bold name when unread */
.live-inbox-conversation-name.has-unread {
  font-weight: 700;
}

/* Chat index counter (e.g. "#1") rendered before the avatar, sized to match it */
.live-inbox-conversation-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #5616ea;
  font-size: 18px;
  font-weight: 700;
}

.live-inbox-conversation-time {
  font-size: 12px;
  color: #9ca3af;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.live-inbox-conversation-preview {
  font-size: 13px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Inline-only markdown inside the preview row: kill block spacing so the
   single-line truncation keeps working. */
.live-inbox-conversation-preview * {
  display: inline;
  margin: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
.live-inbox-conversation-preview a {
  color: #5616ea;
  text-decoration: none;
}
.live-inbox-conversation-preview code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  background: #f3f4f6;
  padding: 0 4px;
  border-radius: 4px;
}

.live-inbox-conversation-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.live-inbox-conversation-bot {
  font-size: 11px;
  color: #9ca3af;
}

.live-inbox-help-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #dc2626;
  background-color: #fef2f2;
  padding: 1px 10px;
  border-radius: 10px;
  font-weight: 500;
  margin-left: 6px;
  vertical-align: baseline;
  position: relative;
  top: 0;
}

.live-inbox-help-badge svg {
  font-size: 11px;
}

.live-inbox-joined-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #166534;
  background-color: #dcfce7;
  padding: 1px 10px;
  border-radius: 10px;
  font-weight: 500;
  margin-left: 6px;
  vertical-align: baseline;
  position: relative;
  top: 0;
}

.live-inbox-joined-badge svg {
  font-size: 11px;
}

/* Task 3 — Unread badge (purple pill) */
.live-inbox-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background-color: #5616ea;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 9px;
  line-height: 1;
}

/* Conversation action buttons */
.live-inbox-conversation-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

/* View button */
.live-inbox-view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  flex-shrink: 0;
  min-width: 96px;
}

.live-inbox-view-btn:hover {
  background-color: #e5e7eb;
  transform: translateY(-1px);
}

.live-inbox-view-btn:active {
  transform: translateY(0);
}

.live-inbox-view-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Join button */
.live-inbox-join-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #5616ea;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  flex-shrink: 0;
  min-width: 96px;
}

.live-inbox-join-btn:hover:not(:disabled) {
  background-color: #4a14d6;
  transform: translateY(-1px);
}

.live-inbox-join-btn:active {
  transform: translateY(0);
}

.live-inbox-join-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Leave button */
.live-inbox-leave-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  flex-shrink: 0;
  min-width: 96px;
}

.live-inbox-leave-btn:hover:not(:disabled) {
  background-color: #fee2e2;
  transform: translateY(-1px);
}

.live-inbox-leave-btn:active {
  transform: translateY(0);
}

.live-inbox-leave-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Full-width join button in view footer */
.live-inbox-join-btn-full {
  width: 100%;
  justify-content: center;
  padding: 12px 20px;
  font-size: 14px;
}

/* View mode badge in header */
.live-inbox-view-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
  background-color: #f3f4f6;
  border-radius: 10px;
  vertical-align: middle;
}

/* View mode footer */
.live-inbox-view-footer {
  display: flex;
  padding: 14px 20px;
  border-top: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.95);
}

/* ============================================
   Chat View (after joining)
   ============================================ */

.live-inbox-chat {
  display: flex;
  flex-direction: column;
  height: 600px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

/* Connecting state: fade chat content and show centered spinner overlay */
.live-inbox-chat.is-connecting {
  position: relative;
}

.live-inbox-chat.is-connecting > .live-inbox-chat-header,
.live-inbox-chat.is-connecting > .live-inbox-chat-messages,
.live-inbox-chat.is-connecting > .live-inbox-chat-input,
.live-inbox-chat.is-connecting > .live-inbox-view-footer {
  opacity: 0.35;
  filter: blur(1px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  transition: opacity 0.2s ease, filter 0.2s ease;
}

.live-inbox-connecting-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  text-align: center;
  pointer-events: auto;
}

.live-inbox-connecting-overlay-spinner {
  font-size: 48px;
  color: #5616ea;
}

.live-inbox-connecting-overlay-title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
}

.live-inbox-connecting-overlay-subtitle {
  font-size: 13px;
  color: #6b7280;
  max-width: 360px;
  line-height: 1.5;
}

/* Chat header */
.live-inbox-chat-header {
  display: flex;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
  gap: 16px;
  background: rgba(255, 255, 255, 0.9);
}

.live-inbox-back-btn {
  all: unset;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #5616ea;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
}

.live-inbox-back-btn svg {
  font-size: 16px;
}

.live-inbox-back-btn:hover {
  color: #4a14d6;
  background-color: #f3f0ff;
}

.live-inbox-chat-header-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.live-inbox-chat-visitor-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.live-inbox-chat-bot-name {
  font-size: 12px;
  color: #9ca3af;
}

.live-inbox-chat-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #166534;
  flex-shrink: 0;
  border-radius: 999px;
  padding: 4px 12px;
  background: transparent;
  transition: background-color 160ms ease, color 160ms ease;
}

/* Reconnecting — visitor briefly unreachable (refresh / short outage) */
.live-inbox-chat-status.presence-away {
  color: #b45309;
  background: #fef3c7;
}
.live-inbox-chat-status.presence-away .status-dot {
  animation: live-inbox-presence-pulse 1.2s ease-in-out infinite;
}

/* In the background — the visitor's tab is hidden but still on the site */
.live-inbox-chat-status.presence-background {
  color: #475569;
  background: #f1f5f9;
}

/* Connection lost — visitor gone past stale timeout */
.live-inbox-chat-status.presence-offline {
  color: #b91c1c;
  background: #fee2e2;
}

@keyframes live-inbox-presence-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.35; }
}

/* Task 5 — status dot base + variants */
.status-dot {
  font-size: 8px;
}

.status-dot.online {
  color: #22c55e;
}

.status-dot.away {
  color: #f59e0b;
}

.status-dot.background {
  color: #94a3b8;
}

.status-dot.offline {
  color: #d1d5db;
}

/* Chat messages */
.live-inbox-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.live-inbox-chat-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.live-inbox-chat-empty p {
  color: #9ca3af;
  font-size: 14px;
}

/* Messages — reuses .chat-message / .message-bubble-history from chatHistoryOverview.css */
.live-inbox-chat-messages .chat-message {
  margin-bottom: 2px;
}

/* Task 2 — Message delivery status */
.msg-status {
  font-size: 10px;
  color: #9ca3af;
}

.msg-status.sent {
  color: #9ca3af;
}

.msg-status.delivered {
  color: #9ca3af;
}

.msg-status.read {
  color: #2563eb;
}

/* Handshake: Connecting / Visitor-offline banner */
.live-inbox-connecting-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin: 0 0 10px 0;
  background-color: #f3eaff;
  border: 1px solid #e0d4f5;
  border-left: 4px solid #5616ea;
  border-radius: 8px;
  color: #4a14d6;
  font-size: 13px;
  line-height: 1.4;
}

.live-inbox-connecting-banner.warn {
  background-color: #fff7ed;
  border-color: #fed7aa;
  border-left-color: #f59e0b;
  color: #92400e;
}

.live-inbox-connecting-banner-sticky {
  position: sticky;
  top: 0;
  z-index: 5;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.live-inbox-connecting-banner svg {
  flex-shrink: 0;
}

/* Task 1 — Visitor typing indicator */
.live-inbox-typing-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: flex-end;
  background-color: #f3f4f6;
  padding: 10px 16px;
  border-radius: 16px;
  border-bottom-right-radius: 4px;
  max-width: 70px;
}

.live-inbox-typing-indicator span {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #9ca3af;
  animation: typingBounce 1.2s ease-in-out infinite;
}

.live-inbox-typing-indicator span:nth-child(2) {
  animation-delay: 0.2s;
}

.live-inbox-typing-indicator span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingBounce {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.5;
  }
  30% {
    transform: translateY(-6px);
    opacity: 1;
  }
}

/* Chat input — matches chatModal.css */
.live-inbox-chat-input {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  border-top: none;
  padding: 10px;
  background-color: white;
}

.live-inbox-chat-input textarea {
  flex: 1 1;
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  font-size: 16px;
  resize: none;
  line-height: 1.4;
  max-height: 140px;
  overflow-y: hidden;
  font-family: "DM Sans", sans-serif;
  box-sizing: border-box;
}

.live-inbox-chat-input textarea.has-overflow {
  overflow-y: auto;
}

.live-inbox-chat-input textarea:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.live-inbox-send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  height: 34px;
  color: white;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: #5616ea;
  transition: background-color 0.4s ease, transform 0.2s ease;
}

.live-inbox-send-btn:hover:not(:disabled) {
  background-color: #4a14d6;
  transform: translateY(-1.5px);
}

.live-inbox-send-btn:disabled {
  background-color: #d1d5db;
  cursor: not-allowed;
}

.live-inbox-send-btn .send-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  display: block;
}

/* ============================================
   Live platform tab highlight
   ============================================ */

.platform-tab-live {
    /* padding-left: 100px !important; */
}

.platform-tab-live.active {
  box-shadow: 0 0 0 1px #5616ea56;
}

/* Pulsing radar dot for Live tab */
.live-radar-dot {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #5616ea;
  margin-right: 4px;
  flex-shrink: 0;
  margin-left: 6px;
  margin-right: 6px;
}

.live-radar-dot::before,
.live-radar-dot::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #5616ea;
  transform: translate(-50%, -50%);
  animation: liveRadarPulse 2s ease-out infinite;
}

.live-radar-dot::after {
  animation-delay: 0.6s;
}

@keyframes liveRadarPulse {
  0% {
    width: 10px;
    height: 10px;
    opacity: 0.8;
  }
  100% {
    width: 30px;
    height: 30px;
    opacity: 0;
  }
}

/* Sidebar radar dot: white by default, purple when selected */
.app-nav-subitem .live-radar-dot {
  background-color: #ffffff;
}
.app-nav-subitem .live-radar-dot::before,
.app-nav-subitem .live-radar-dot::after {
  border-color: #ffffff;
}
.app-nav-subitem.selected .live-radar-dot {
  background-color: #5616ea;
}
.app-nav-subitem.selected .live-radar-dot::before,
.app-nav-subitem.selected .live-radar-dot::after {
  border-color: #5616ea;
}

/* ============================================
   Responsive
   ============================================ */

@media (max-width: 768px) {
  .live-inbox-status-bar {
    flex-direction: column;
  }

  .live-inbox-bot-status {
    width: 100%;
    box-sizing: border-box;
    /* Drop the "Manage Notifications" button below the info text. */
    flex-direction: column;
    align-items: stretch;
  }
  .live-inbox-bot-status .live-inbox-toggle {
    width: 100%;
  }

  /* Agent availability "Other agents" empty state: the Invite / add team
     member button stacks below the "No other agents…" text instead of
     sitting beside it. */
  .live-inbox-agent-empty-block {
    flex-direction: column;
    align-items: stretch;
  }
  .live-inbox-agent-empty-block .live-inbox-invite-btn {
    width: 100%;
  }

  .live-inbox-conversation-item {
    flex-wrap: wrap;
  }

  /* Allow visitor name + status badges to wrap onto a new line on mobile so
     "Help requested" / "Agent joined" pills are not clipped by ellipsis. */
  .live-inbox-conversation-name {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 4px;
  }

  .live-inbox-help-badge,
  .live-inbox-joined-badge {
    margin-left: 0;
  }

  .live-inbox-conversation-actions {
    width: 100%;
    flex-direction: column;
  }

  .live-inbox-view-btn,
  .live-inbox-join-btn,
  .live-inbox-leave-btn {
    width: 100%;
    justify-content: center;
  }

  .live-inbox-chat {
    height: calc(100vh - 160px);
    min-height: 400px;
    border-radius: 0;
  }

  /* Chat header — wrap so leave/join button drop below instead of overflowing */
  .live-inbox-chat-header {
    flex-wrap: wrap;
    gap: 8px 10px;
    padding: 10px 12px;
  }

  .live-inbox-back-btn {
    padding: 4px 8px;
    font-size: 13px;
  }

  .live-inbox-chat-header-info {
    flex: 1 1 auto;
    min-width: 0;
  }

  .live-inbox-chat-visitor-name {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .live-inbox-chat-bot-name {
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .live-inbox-chat-status {
    font-size: 12px;
    padding: 3px 8px;
    flex-shrink: 0;
  }

  /* Drop the leave/join button onto its own row, full width */
  .live-inbox-chat-header > .live-inbox-leave-btn,
  .live-inbox-chat-header > .live-inbox-join-btn {
    flex-basis: 100%;
    width: 100%;
    min-width: 0;
    margin: 0;
    order: 99;
  }
}


/* ---------------------------------------------------------------
   Agent assist: translation + AI-suggested replies
   --------------------------------------------------------------- */
.live-inbox-chat-input-wrap {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.live-inbox-chat-input-wrap .live-inbox-chat-input {
  border-top: none;
}

.live-inbox-assist-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  padding: 8px 12px;
  background: #fafafa;
  border-bottom: 1px solid #eef0f3;
  font-size: 12px;
}

.live-inbox-assist-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.live-inbox-assist-group-end {
  margin-left: auto;
}

.live-inbox-assist-label {
  color: #6b7280;
  font-weight: 500;
  font-size: 12px;
  white-space: nowrap;
}

.live-inbox-assist-select {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  padding: 4px 8px;
  font-size: 12px;
  color: #111827;
  cursor: pointer;
  outline: none;
  max-width: 160px;
}

.live-inbox-assist-select:hover {
  border-color: #a8abb2;
}

.live-inbox-assist-select:focus {
  border-color: #5616ea;
  box-shadow: 0 0 0 2px rgba(86, 22, 234, 0.15);
}

.live-inbox-assist-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #5616ea;
  background: linear-gradient(135deg, #5616ea 0%, #7b3ff5 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.live-inbox-assist-btn:hover:not(:disabled) {
  box-shadow: 0 2px 6px rgba(86, 22, 234, 0.35);
  transform: translateY(-1px);
}

.live-inbox-assist-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.live-inbox-assist-credits {
  font-size: 11px;
  color: #6b7280;
  padding: 3px 8px;
  border-radius: 10px;
  background: #f3f4f6;
  white-space: nowrap;
}

.live-inbox-assist-credits.is-exhausted {
  background: #fee2e2;
  color: #b91c1c;
  font-weight: 600;
}

/* Per-message translate row (hyperlink + flag/code select beneath bubble). */
.message-translate-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
  padding-left: 2px;
  font-size: 11px;
  line-height: 1;
}

.message-translate-link {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 11px;
  color: #5616ea;
  cursor: pointer;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.message-translate-link:hover:not(:disabled) {
  color: #4a14d6;
  text-decoration-thickness: 1.5px;
}

.message-translate-link:disabled {
  color: #9ca3af;
  cursor: default;
  text-decoration: none;
}

.message-lang-picker {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.message-lang-trigger {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 4px;
  padding: 1px 5px;
  height: 20px;
  font-size: 11px;
  line-height: 1;
  color: #374151;
  cursor: pointer;
  font-family: inherit;
}

.message-lang-trigger:hover:not(:disabled) {
  border-color: #c0c4cb;
  background: #fafafa;
}

.message-lang-trigger:focus {
  outline: none;
  border-color: #5616ea;
  box-shadow: 0 0 0 2px rgba(86, 22, 234, 0.12);
}

.message-lang-trigger:disabled {
  opacity: 0.6;
  cursor: default;
}

.message-lang-flag {
  display: block;
  width: 16px;
  height: auto;
  border-radius: 1px;
  object-fit: cover;
  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.1);
}

.message-lang-code {
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-size: 10px;
  color: #4b5563;
}

.message-lang-caret {
  font-size: 9px;
  color: #9ca3af;
}

.message-lang-menu {
  /* Positioning is set inline by the portal-based MessageLangMenu component
     (position: fixed + computed top/left/width/maxHeight) so the menu can
     never be clipped by the chat scroll container or expand the chat
     window. The styles below only cover appearance + scroll behaviour. */
  z-index: 1000;
  width: max-content;
  min-width: 160px;
  max-width: min(240px, calc(100vw - 16px));
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  padding: 4px;
  overscroll-behavior: contain;
}

.message-lang-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: none;
  background: transparent;
  padding: 5px 8px;
  font-size: 12px;
  color: #374151;
  cursor: pointer;
  border-radius: 4px;
  text-align: left;
  font-family: inherit;
}

.message-lang-option:hover {
  background: #f3f4f6;
}

.message-lang-option.is-active {
  background: #eef0fb;
  color: #5616ea;
  font-weight: 600;
}

.message-lang-option .message-lang-flag {
  width: 18px;
}

.message-lang-option .message-lang-code {
  min-width: 22px;
}

.message-lang-name {
  font-size: 12px;
  color: inherit;
  flex: 1 1;
}

.message-translate-spinner {
  font-size: 10px;
  color: #5616ea;
}

/* Translated text shown under the visitor's message bubble. */
.message-translation {
  margin-top: 6px;
  padding: 6px 10px;
  background: #f9fafb;
  border: 1px solid #eef0f3;
  border-left: 3px solid #5616ea;
  border-radius: 6px;
  font-size: 13px;
  color: #4b5563;
  font-style: italic;
  max-width: 80%;
  align-self: flex-end;
}

.message-translation-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
  font-style: normal;
}

.message-translation-text {
  font-style: italic;
  line-height: 1.45;
}

.message-translation-text p {
  margin: 2px 0;
}

.message-translation-error {
  color: #b91c1c;
  font-style: italic;
  font-size: 12px;
}

@media (max-width: 640px) {
  .live-inbox-assist-toolbar {
    gap: 6px 10px;
    padding: 6px 10px;
  }
  .live-inbox-assist-select {
    max-width: 120px;
  }
  .live-inbox-assist-group-end {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
}


/* ---------------------------------------------------------------
   Inline action buttons (suggest reply + translate input)
   placed left of the send button inside .live-inbox-chat-input
   --------------------------------------------------------------- */
.live-inbox-chat-input-textwrap {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: stretch;
}

.live-inbox-chat-input-textwrap > textarea {
  flex: 1 1;
  width: 100%;
}

.live-inbox-input-busy-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  border-radius: 8px;
  background: #f5f5f5;
  border: 1px solid #ccc;
  pointer-events: auto;
  z-index: 2;
}

.live-inbox-input-busy-spinner {
  color: #5616ea;
  font-size: 14px;
  flex-shrink: 0;
}

.live-inbox-input-busy-label {
  flex: 1 1;
  min-width: 0;
  font-size: 14px;
  color: #4b5563;
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.live-inbox-input-busy-cancel {
  flex-shrink: 0;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #4b5563;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.live-inbox-input-busy-cancel:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.live-inbox-input-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #5616ea;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  font-family: inherit;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.live-inbox-input-action-btn svg {
  font-size: 15px;
}

.live-inbox-input-action-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1px;
}

.live-inbox-input-action-btn:hover:not(:disabled) {
  background: #f3f0ff;
  border-color: #d4c8fb;
  transform: translateY(-1px);
}

.live-inbox-input-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  color: #9ca3af;
}

@media (max-width: 640px) {
  .live-inbox-input-action-label {
    display: none;
  }
  .live-inbox-input-action-btn {
    width: 34px;
    padding: 0;
  }
}

.live-inbox-input-translate {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.live-inbox-input-translate-menu {
  position: absolute;
  bottom: calc(100% + 6px);
  right: 0;
  z-index: 50;
  width: max-content;
  min-width: 170px;
  max-width: min(220px, calc(100vw - 32px));
  max-height: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  padding: 4px;
  overscroll-behavior: contain;
}
`, "",{"version":3,"sources":["webpack://./src/components/liveInbox.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB;iEAC+D;EAC/D,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;oEAEoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;8DAC8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;gEAGgE;AAChE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mEAAmE;EACnE,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;;;kEAKkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;;oEAEoE;AACpE;EACE,oBAAoB;AACtB;;AAEA;6CAC6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf;;;qBAGmB;EACnB,WAAW;AACb;;AAEA;;;;0BAI0B;AAC1B;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;;;0DAG0D;AAC1D;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;0EAC0E;AAC1E;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;AAClB;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;0CAC0C;AAC1C;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA,wEAAwE;AACxE;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,8DAA8D;AAChE;;AAEA,0EAA0E;AAC1E;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,aAAa,EAAE;AACvB;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;IACxB,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;IACI,oCAAoC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,qBAAqB;AACvB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,gEAAgE;IAChE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;;EAEA;;yBAEuB;EACvB;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;2EACyE;EACzE;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,YAAY;EACd;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,8EAA8E;EAC9E;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA,4DAA4D;EAC5D;;IAEE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,SAAS;EACX;AACF;;;AAGA;;oEAEoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,6EAA6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;;;yEAGuE;EACvE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,8BAA8B;EAChC;AACF;;;AAGA;;;oEAGoE;AACpE;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,wGAAwG;AAC1G;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,4BAA4B;AAC9B","sourcesContent":["/* ============================================\r\n   Live Inbox – Main Container\r\n   ============================================ */\r\n\r\n.live-inbox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.live-inbox-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px;\r\n}\r\n\r\n/* ============================================\r\n   Empty / Not Enabled State\r\n   ============================================ */\r\n\r\n.live-inbox-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px 24px;\r\n  background-color: #f9fafb;\r\n  border: 1px dashed #d1d5db;\r\n  border-radius: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.live-inbox-empty-icon {\r\n  font-size: 48px;\r\n  color: #9ca3af;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.live-inbox-empty h3 {\r\n  margin: 0 0 8px 0;\r\n  color: #111827;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n}\r\n\r\n.live-inbox-empty p {\r\n  margin: 0 0 24px 0;\r\n  color: #6b7280;\r\n  font-size: 15px;\r\n  max-width: 450px;\r\n}\r\n\r\n.live-inbox-setup-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 12px 24px;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 15px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.live-inbox-setup-btn:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n/* ============================================\r\n   Status Bar (Online/Offline toggles)\r\n   ============================================ */\r\n\r\n.live-inbox-status-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.live-inbox-bot-status {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  padding: 14px 20px;\r\n  border: 1px solid #e5e7eb;\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.live-inbox-bot-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.live-inbox-bot-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.live-inbox-bot-desc {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  line-height: 1.4;\r\n}\r\n\r\n.live-inbox-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 4px 14px;\r\n  border-radius: 20px;\r\n  /* Reserve a 1px border slot so disabled / enabled variants share\r\n     identical geometry. The base variants keep it transparent. */\r\n  border: 1px solid transparent;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  min-width: 110px;\r\n}\r\n\r\n.live-inbox-toggle.online {\r\n  background-color: #ede9fe;\r\n  color: #5616ea;\r\n}\r\n\r\n.live-inbox-toggle.online:hover:not(:disabled):not(.is-disabled) {\r\n  background-color: #ddd6fe;\r\n}\r\n\r\n.live-inbox-toggle.offline {\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n}\r\n\r\n.live-inbox-toggle.offline:hover:not(:disabled):not(.is-disabled) {\r\n  background-color: #fee2e2;\r\n}\r\n\r\n.live-inbox-toggle:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.live-inbox-toggle svg:first-child {\r\n  font-size: 18px;\r\n}\r\n\r\n/* ============================================\r\n   Availability section (per bot)\r\n   ============================================ */\r\n\r\n.live-inbox-availability {\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  padding: 16px 20px 14px;\r\n  border: 1px solid #e5e7eb;\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.live-inbox-availability-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding-bottom: 14px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.live-inbox-availability-title-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.live-inbox-availability-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n/* Card title treatment shared by the Availability and Notifications\r\n   cards: short purple bar on the left + title text + InfoTooltip on\r\n   the right. Mirrors the .widget-sub-header style used elsewhere. */\r\n.live-inbox-card-title {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: #5616ea;\r\n}\r\n\r\n.live-inbox-card-title::before {\r\n  content: '';\r\n  display: inline-block;\r\n  width: 4px;\r\n  height: 18px;\r\n  background-color: #5616ea;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.live-inbox-availability-desc {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  line-height: 1.4;\r\n}\r\n\r\n.live-inbox-availability-count {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  background: #f3f4f6;\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Spinner shown while the initial agent_status + roster fetches are\r\n   still in flight. Sits in the same slot as the count chip. */\r\n.live-inbox-availability-loading {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.live-inbox-agent-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n/* When the \"Other agents\" group has more than 3 entries, cap the list\r\n   to roughly 3 rows tall and let the rest scroll. Row = ~32px\r\n   (toggle 28px + 4px gap). 3 * 32 = 96px, plus a hairline of breathing\r\n   room so the 4th row is half-visible as a scroll affordance. */\r\n.live-inbox-agent-list.is-scrollable {\r\n  max-height: 108px;\r\n  overflow-y: auto;\r\n  /* Reserve space for the scrollbar so rows don't reflow on hover. */\r\n  padding-right: 4px;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #d1d5db transparent;\r\n}\r\n\r\n.live-inbox-agent-list.is-scrollable::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.live-inbox-agent-list.is-scrollable::-webkit-scrollbar-thumb {\r\n  background-color: #d1d5db;\r\n  border-radius: 3px;\r\n}\r\n\r\n.live-inbox-agent-list.is-scrollable::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.live-inbox-agent-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 6px 4px;\r\n  font-size: 13px;\r\n  color: #111827;\r\n  border-radius: 8px;\r\n}\r\n\r\n.live-inbox-agent-row + .live-inbox-agent-row {\r\n  border-top: 1px solid #f3f4f6;\r\n}\r\n\r\n.live-inbox-agent-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n  background: #dc2626;\r\n}\r\n\r\n.live-inbox-agent-dot.online {\r\n  background: #10b981;\r\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.18);\r\n}\r\n\r\n.live-inbox-agent-dot.offline {\r\n  background: #dc2626;\r\n  box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.18);\r\n}\r\n\r\n.live-inbox-agent-name {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-inbox-agent-you {\r\n  color: #9ca3af;\r\n  font-weight: 500;\r\n}\r\n\r\n.live-inbox-agent-role {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  background: #f3f4f6;\r\n  padding: 1px 6px;\r\n  border-radius: 8px;\r\n  text-transform: capitalize;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* The toggle on a teammate row reuses .live-inbox-toggle. When the\r\n   current user can't act on it, we add .is-disabled. We deliberately\r\n   avoid opacity / grayscale here because they make the pill look\r\n   visually smaller next to its enabled siblings. Instead we keep the\r\n   full-strength background and add a tinted border so the silhouette\r\n   reads as the same size and weight as the interactive variant. */\r\n.live-inbox-toggle.is-disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Tooltip wrapper around the toggle. Needed because MUI Tooltip can't\r\n   attach pointer listeners to a disabled button directly. The wrap\r\n   should be invisible to layout (inline-flex, no padding/margin). */\r\n.live-inbox-toggle-wrap {\r\n  display: inline-flex;\r\n}\r\n\r\n/* Sectioning inside the availability card: \"My availability\" then a\r\n   strong divider and \"Other agents\" below. */\r\n.live-inbox-agent-section {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.live-inbox-agent-section-header {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: #6b7280;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.live-inbox-agent-section-divider {\r\n  height: 1px;\r\n  background: #e5e7eb;\r\n  margin: 6px 0 8px;\r\n}\r\n\r\n.live-inbox-agent-empty {\r\n  font-size: 13px;\r\n  color: #9ca3af;\r\n  font-style: italic;\r\n  padding: 0;\r\n}\r\n\r\n.live-inbox-agent-empty-block {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 0;\r\n}\r\n\r\n.live-inbox-invite-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 4px 14px;\r\n  border-radius: 20px;\r\n  border: 1px solid transparent;\r\n  background-color: #ede9fe;\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  min-width: 110px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-inbox-invite-btn:hover {\r\n  background-color: #ddd6fe;\r\n}\r\n\r\n.live-inbox-invite-btn svg {\r\n  font-size: 18px;\r\n  /* faUserPlus has a wider glyph than faBell at the same font-size,\r\n     which would otherwise make this pill noticeably wider than the\r\n     Manage Notifications pill. Cap the rendered width so both buttons\r\n     match in size. */\r\n  width: 16px;\r\n}\r\n\r\n/* Keep the disabled toggle's background identical to its non-hover state\r\n   and add a tinted border so it carries the same visual weight as an\r\n   interactive pill. Using `inherit` for background pulls the row's\r\n   transparent background and visually wipes the pill, so we re-assert\r\n   the per-state colors. */\r\n.live-inbox-toggle.online.is-disabled,\r\n.live-inbox-toggle.online:disabled,\r\n.live-inbox-toggle.online.is-disabled:hover,\r\n.live-inbox-toggle.online:disabled:hover {\r\n  background-color: #ede9fe;\r\n  border-color: #c4b5fd;\r\n  color: #6d28d9;\r\n}\r\n\r\n.live-inbox-toggle.offline.is-disabled,\r\n.live-inbox-toggle.offline:disabled,\r\n.live-inbox-toggle.offline.is-disabled:hover,\r\n.live-inbox-toggle.offline:disabled:hover {\r\n  background-color: #fef2f2;\r\n  border-color: #fecaca;\r\n  color: #b91c1c;\r\n}\r\n\r\n/* ============================================\r\n   No Conversations / Waiting State\r\n   ============================================ */\r\n\r\n.live-inbox-no-conversations {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 24px;\r\n  background: rgba(255, 255, 255, 0.75);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  text-align: center;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.live-inbox-no-conversations-icon {\r\n  font-size: 40px;\r\n  color: #d1d5db;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.live-inbox-no-conversations h3 {\r\n  margin: 0 0 8px 0;\r\n  color: #111827;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n}\r\n\r\n.live-inbox-no-conversations p {\r\n  margin: 0;\r\n  color: #6b7280;\r\n  font-size: 14px;\r\n  max-width: 420px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* ============================================\r\n   Conversation List\r\n   ============================================ */\r\n\r\n/* Conversations card — same chrome (white bg, border, radius, padding,\r\n   width) as the Availability and Notifications cards above, so the\r\n   \"Current Conversations\" header and its content sit inside one\r\n   container instead of floating on the page background. */\r\n.live-inbox-conversations {\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  padding: 16px 20px 14px;\r\n  border: 1px solid #e5e7eb;\r\n  width: 100%;\r\n  max-width: 1100px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* \"Current Conversations\" header inside the card — reuses\r\n   .live-inbox-card-title (purple bar + text) and mirrors the divider\r\n   treatment of .live-inbox-availability-header. */\r\n.live-inbox-conversations-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding-bottom: 14px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n/* Inside the conversations card the empty state and loading spinner are\r\n   already wrapped, so drop their own card chrome to avoid a box-in-box. */\r\n.live-inbox-conversations .live-inbox-no-conversations {\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 0;\r\n  padding: 40px 24px;\r\n}\r\n\r\n.live-inbox-conversation-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.live-inbox-conversation-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 20px 18px;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  border: 1px solid #e5e7eb;\r\n  transition: border-color 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.live-inbox-conversation-item:focus-visible {\r\n  outline: 2px solid #5616ea;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.live-inbox-conversation-item:hover {\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.live-inbox-conversation-avatar {\r\n  width: 42px;\r\n  height: 42px;\r\n  border-radius: 50%;\r\n  background-color: #f3f4f6;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #9ca3af;\r\n  font-size: 16px;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n}\r\n\r\n/* Task 5 — presence dot on avatar */\r\n.live-inbox-conversation-avatar .avatar-presence {\r\n  position: absolute;\r\n  bottom: 1px;\r\n  right: 1px;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  border: 2px solid #ffffff;\r\n  font-size: 0;\r\n}\r\n\r\n.live-inbox-conversation-avatar .avatar-presence.online {\r\n  background-color: #22c55e;\r\n}\r\n\r\n.live-inbox-conversation-avatar .avatar-presence.away {\r\n  background-color: #f59e0b;\r\n}\r\n\r\n.live-inbox-conversation-avatar .avatar-presence.background {\r\n  background-color: #94a3b8;\r\n}\r\n\r\n.live-inbox-conversation-avatar .avatar-presence.offline {\r\n  background-color: #d1d5db;\r\n}\r\n\r\n.live-inbox-conversation-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 3px;\r\n}\r\n\r\n.live-inbox-conversation-right {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  min-width: 50px;\r\n}\r\n\r\n.live-inbox-conversation-name {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Task 3 — bold name when unread */\r\n.live-inbox-conversation-name.has-unread {\r\n  font-weight: 700;\r\n}\r\n\r\n/* Chat index counter (e.g. \"#1\") rendered before the avatar, sized to match it */\r\n.live-inbox-conversation-index {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  color: #5616ea;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n}\r\n\r\n.live-inbox-conversation-time {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.live-inbox-conversation-preview {\r\n  font-size: 13px;\r\n  color: #6b7280;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Inline-only markdown inside the preview row: kill block spacing so the\r\n   single-line truncation keeps working. */\r\n.live-inbox-conversation-preview * {\r\n  display: inline;\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n  color: inherit;\r\n}\r\n.live-inbox-conversation-preview a {\r\n  color: #5616ea;\r\n  text-decoration: none;\r\n}\r\n.live-inbox-conversation-preview code {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\r\n  font-size: 12px;\r\n  background: #f3f4f6;\r\n  padding: 0 4px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.live-inbox-conversation-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.live-inbox-conversation-bot {\r\n  font-size: 11px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.live-inbox-help-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 14px;\r\n  color: #dc2626;\r\n  background-color: #fef2f2;\r\n  padding: 1px 10px;\r\n  border-radius: 10px;\r\n  font-weight: 500;\r\n  margin-left: 6px;\r\n  vertical-align: baseline;\r\n  position: relative;\r\n  top: 0;\r\n}\r\n\r\n.live-inbox-help-badge svg {\r\n  font-size: 11px;\r\n}\r\n\r\n.live-inbox-joined-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 14px;\r\n  color: #166534;\r\n  background-color: #dcfce7;\r\n  padding: 1px 10px;\r\n  border-radius: 10px;\r\n  font-weight: 500;\r\n  margin-left: 6px;\r\n  vertical-align: baseline;\r\n  position: relative;\r\n  top: 0;\r\n}\r\n\r\n.live-inbox-joined-badge svg {\r\n  font-size: 11px;\r\n}\r\n\r\n/* Task 3 — Unread badge (purple pill) */\r\n.live-inbox-unread-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 5px;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  border-radius: 9px;\r\n  line-height: 1;\r\n}\r\n\r\n/* Conversation action buttons */\r\n.live-inbox-conversation-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* View button */\r\n.live-inbox-view-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  background-color: #f3f4f6;\r\n  color: #374151;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, transform 0.1s;\r\n  flex-shrink: 0;\r\n  min-width: 96px;\r\n}\r\n\r\n.live-inbox-view-btn:hover {\r\n  background-color: #e5e7eb;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-inbox-view-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.live-inbox-view-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Join button */\r\n.live-inbox-join-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  background-color: #5616ea;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, transform 0.1s;\r\n  flex-shrink: 0;\r\n  min-width: 96px;\r\n}\r\n\r\n.live-inbox-join-btn:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-inbox-join-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.live-inbox-join-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Leave button */\r\n.live-inbox-leave-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 8px 16px;\r\n  background-color: #fef2f2;\r\n  color: #dc2626;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 10px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, transform 0.1s;\r\n  flex-shrink: 0;\r\n  min-width: 96px;\r\n}\r\n\r\n.live-inbox-leave-btn:hover:not(:disabled) {\r\n  background-color: #fee2e2;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-inbox-leave-btn:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.live-inbox-leave-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Full-width join button in view footer */\r\n.live-inbox-join-btn-full {\r\n  width: 100%;\r\n  justify-content: center;\r\n  padding: 12px 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n/* View mode badge in header */\r\n.live-inbox-view-badge {\r\n  display: inline-block;\r\n  margin-left: 8px;\r\n  padding: 1px 8px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  background-color: #f3f4f6;\r\n  border-radius: 10px;\r\n  vertical-align: middle;\r\n}\r\n\r\n/* View mode footer */\r\n.live-inbox-view-footer {\r\n  display: flex;\r\n  padding: 14px 20px;\r\n  border-top: 1px solid #e5e7eb;\r\n  background: rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n/* ============================================\r\n   Chat View (after joining)\r\n   ============================================ */\r\n\r\n.live-inbox-chat {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 600px;\r\n  background: rgba(255, 255, 255, 0.85);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 10px;\r\n  border: 1px solid #e5e7eb;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Connecting state: fade chat content and show centered spinner overlay */\r\n.live-inbox-chat.is-connecting {\r\n  position: relative;\r\n}\r\n\r\n.live-inbox-chat.is-connecting > .live-inbox-chat-header,\r\n.live-inbox-chat.is-connecting > .live-inbox-chat-messages,\r\n.live-inbox-chat.is-connecting > .live-inbox-chat-input,\r\n.live-inbox-chat.is-connecting > .live-inbox-view-footer {\r\n  opacity: 0.35;\r\n  filter: blur(1px);\r\n  pointer-events: none;\r\n  user-select: none;\r\n  transition: opacity 0.2s ease, filter 0.2s ease;\r\n}\r\n\r\n.live-inbox-connecting-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 10;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 14px;\r\n  padding: 24px;\r\n  background: rgba(255, 255, 255, 0.55);\r\n  backdrop-filter: blur(4px);\r\n  -webkit-backdrop-filter: blur(4px);\r\n  text-align: center;\r\n  pointer-events: auto;\r\n}\r\n\r\n.live-inbox-connecting-overlay-spinner {\r\n  font-size: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.live-inbox-connecting-overlay-title {\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  color: #1f2937;\r\n}\r\n\r\n.live-inbox-connecting-overlay-subtitle {\r\n  font-size: 13px;\r\n  color: #6b7280;\r\n  max-width: 360px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Chat header */\r\n.live-inbox-chat-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 14px 20px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n  gap: 16px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n.live-inbox-back-btn {\r\n  all: unset;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #5616ea;\r\n  transition: color 0.2s, background-color 0.2s;\r\n  flex-shrink: 0;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.live-inbox-back-btn svg {\r\n  font-size: 16px;\r\n}\r\n\r\n.live-inbox-back-btn:hover {\r\n  color: #4a14d6;\r\n  background-color: #f3f0ff;\r\n}\r\n\r\n.live-inbox-chat-header-info {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.live-inbox-chat-visitor-name {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: #111827;\r\n}\r\n\r\n.live-inbox-chat-bot-name {\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.live-inbox-chat-status {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 13px;\r\n  color: #166534;\r\n  flex-shrink: 0;\r\n  border-radius: 999px;\r\n  padding: 4px 12px;\r\n  background: transparent;\r\n  transition: background-color 160ms ease, color 160ms ease;\r\n}\r\n\r\n/* Reconnecting — visitor briefly unreachable (refresh / short outage) */\r\n.live-inbox-chat-status.presence-away {\r\n  color: #b45309;\r\n  background: #fef3c7;\r\n}\r\n.live-inbox-chat-status.presence-away .status-dot {\r\n  animation: live-inbox-presence-pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n/* In the background — the visitor's tab is hidden but still on the site */\r\n.live-inbox-chat-status.presence-background {\r\n  color: #475569;\r\n  background: #f1f5f9;\r\n}\r\n\r\n/* Connection lost — visitor gone past stale timeout */\r\n.live-inbox-chat-status.presence-offline {\r\n  color: #b91c1c;\r\n  background: #fee2e2;\r\n}\r\n\r\n@keyframes live-inbox-presence-pulse {\r\n  0%, 100% { opacity: 1; }\r\n  50% { opacity: 0.35; }\r\n}\r\n\r\n/* Task 5 — status dot base + variants */\r\n.status-dot {\r\n  font-size: 8px;\r\n}\r\n\r\n.status-dot.online {\r\n  color: #22c55e;\r\n}\r\n\r\n.status-dot.away {\r\n  color: #f59e0b;\r\n}\r\n\r\n.status-dot.background {\r\n  color: #94a3b8;\r\n}\r\n\r\n.status-dot.offline {\r\n  color: #d1d5db;\r\n}\r\n\r\n/* Chat messages */\r\n.live-inbox-chat-messages {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.live-inbox-chat-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.live-inbox-chat-empty p {\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Messages — reuses .chat-message / .message-bubble-history from chatHistoryOverview.css */\r\n.live-inbox-chat-messages .chat-message {\r\n  margin-bottom: 2px;\r\n}\r\n\r\n/* Task 2 — Message delivery status */\r\n.msg-status {\r\n  font-size: 10px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.msg-status.sent {\r\n  color: #9ca3af;\r\n}\r\n\r\n.msg-status.delivered {\r\n  color: #9ca3af;\r\n}\r\n\r\n.msg-status.read {\r\n  color: #2563eb;\r\n}\r\n\r\n/* Handshake: Connecting / Visitor-offline banner */\r\n.live-inbox-connecting-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px 14px;\r\n  margin: 0 0 10px 0;\r\n  background-color: #f3eaff;\r\n  border: 1px solid #e0d4f5;\r\n  border-left: 4px solid #5616ea;\r\n  border-radius: 8px;\r\n  color: #4a14d6;\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n}\r\n\r\n.live-inbox-connecting-banner.warn {\r\n  background-color: #fff7ed;\r\n  border-color: #fed7aa;\r\n  border-left-color: #f59e0b;\r\n  color: #92400e;\r\n}\r\n\r\n.live-inbox-connecting-banner-sticky {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 5;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.live-inbox-connecting-banner svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Task 1 — Visitor typing indicator */\r\n.live-inbox-typing-indicator {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  align-self: flex-end;\r\n  background-color: #f3f4f6;\r\n  padding: 10px 16px;\r\n  border-radius: 16px;\r\n  border-bottom-right-radius: 4px;\r\n  max-width: 70px;\r\n}\r\n\r\n.live-inbox-typing-indicator span {\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background-color: #9ca3af;\r\n  animation: typingBounce 1.2s ease-in-out infinite;\r\n}\r\n\r\n.live-inbox-typing-indicator span:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.live-inbox-typing-indicator span:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n@keyframes typingBounce {\r\n  0%, 60%, 100% {\r\n    transform: translateY(0);\r\n    opacity: 0.5;\r\n  }\r\n  30% {\r\n    transform: translateY(-6px);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Chat input — matches chatModal.css */\r\n.live-inbox-chat-input {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 6px;\r\n  border-top: none;\r\n  padding: 10px;\r\n  background-color: white;\r\n}\r\n\r\n.live-inbox-chat-input textarea {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 8px;\r\n  outline: none;\r\n  font-size: 16px;\r\n  resize: none;\r\n  line-height: 1.4;\r\n  max-height: 140px;\r\n  overflow-y: hidden;\r\n  font-family: \"DM Sans\", sans-serif;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.live-inbox-chat-input textarea.has-overflow {\r\n  overflow-y: auto;\r\n}\r\n\r\n.live-inbox-chat-input textarea:disabled {\r\n  background-color: #f5f5f5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.live-inbox-send-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 15px;\r\n  height: 34px;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  background-color: #5616ea;\r\n  transition: background-color 0.4s ease, transform 0.2s ease;\r\n}\r\n\r\n.live-inbox-send-btn:hover:not(:disabled) {\r\n  background-color: #4a14d6;\r\n  transform: translateY(-1.5px);\r\n}\r\n\r\n.live-inbox-send-btn:disabled {\r\n  background-color: #d1d5db;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.live-inbox-send-btn .send-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: currentColor;\r\n  display: block;\r\n}\r\n\r\n/* ============================================\r\n   Live platform tab highlight\r\n   ============================================ */\r\n\r\n.platform-tab-live {\r\n    /* padding-left: 100px !important; */\r\n}\r\n\r\n.platform-tab-live.active {\r\n  box-shadow: 0 0 0 1px #5616ea56;\r\n}\r\n\r\n/* Pulsing radar dot for Live tab */\r\n.live-radar-dot {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background-color: #5616ea;\r\n  margin-right: 4px;\r\n  flex-shrink: 0;\r\n  margin-left: 6px;\r\n  margin-right: 6px;\r\n}\r\n\r\n.live-radar-dot::before,\r\n.live-radar-dot::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  border: 2px solid #5616ea;\r\n  transform: translate(-50%, -50%);\r\n  animation: liveRadarPulse 2s ease-out infinite;\r\n}\r\n\r\n.live-radar-dot::after {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n@keyframes liveRadarPulse {\r\n  0% {\r\n    width: 10px;\r\n    height: 10px;\r\n    opacity: 0.8;\r\n  }\r\n  100% {\r\n    width: 30px;\r\n    height: 30px;\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* Sidebar radar dot: white by default, purple when selected */\r\n.app-nav-subitem .live-radar-dot {\r\n  background-color: #ffffff;\r\n}\r\n.app-nav-subitem .live-radar-dot::before,\r\n.app-nav-subitem .live-radar-dot::after {\r\n  border-color: #ffffff;\r\n}\r\n.app-nav-subitem.selected .live-radar-dot {\r\n  background-color: #5616ea;\r\n}\r\n.app-nav-subitem.selected .live-radar-dot::before,\r\n.app-nav-subitem.selected .live-radar-dot::after {\r\n  border-color: #5616ea;\r\n}\r\n\r\n/* ============================================\r\n   Responsive\r\n   ============================================ */\r\n\r\n@media (max-width: 768px) {\r\n  .live-inbox-status-bar {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .live-inbox-bot-status {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    /* Drop the \"Manage Notifications\" button below the info text. */\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  .live-inbox-bot-status .live-inbox-toggle {\r\n    width: 100%;\r\n  }\r\n\r\n  /* Agent availability \"Other agents\" empty state: the Invite / add team\r\n     member button stacks below the \"No other agents…\" text instead of\r\n     sitting beside it. */\r\n  .live-inbox-agent-empty-block {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n  .live-inbox-agent-empty-block .live-inbox-invite-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .live-inbox-conversation-item {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  /* Allow visitor name + status badges to wrap onto a new line on mobile so\r\n     \"Help requested\" / \"Agent joined\" pills are not clipped by ellipsis. */\r\n  .live-inbox-conversation-name {\r\n    white-space: normal;\r\n    overflow: visible;\r\n    text-overflow: clip;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    row-gap: 4px;\r\n  }\r\n\r\n  .live-inbox-help-badge,\r\n  .live-inbox-joined-badge {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .live-inbox-conversation-actions {\r\n    width: 100%;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .live-inbox-view-btn,\r\n  .live-inbox-join-btn,\r\n  .live-inbox-leave-btn {\r\n    width: 100%;\r\n    justify-content: center;\r\n  }\r\n\r\n  .live-inbox-chat {\r\n    height: calc(100vh - 160px);\r\n    min-height: 400px;\r\n    border-radius: 0;\r\n  }\r\n\r\n  /* Chat header — wrap so leave/join button drop below instead of overflowing */\r\n  .live-inbox-chat-header {\r\n    flex-wrap: wrap;\r\n    gap: 8px 10px;\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .live-inbox-back-btn {\r\n    padding: 4px 8px;\r\n    font-size: 13px;\r\n  }\r\n\r\n  .live-inbox-chat-header-info {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n  }\r\n\r\n  .live-inbox-chat-visitor-name {\r\n    font-size: 14px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .live-inbox-chat-bot-name {\r\n    font-size: 11px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .live-inbox-chat-status {\r\n    font-size: 12px;\r\n    padding: 3px 8px;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  /* Drop the leave/join button onto its own row, full width */\r\n  .live-inbox-chat-header > .live-inbox-leave-btn,\r\n  .live-inbox-chat-header > .live-inbox-join-btn {\r\n    flex-basis: 100%;\r\n    width: 100%;\r\n    min-width: 0;\r\n    margin: 0;\r\n    order: 99;\r\n  }\r\n}\r\n\r\n\r\n/* ---------------------------------------------------------------\r\n   Agent assist: translation + AI-suggested replies\r\n   --------------------------------------------------------------- */\r\n.live-inbox-chat-input-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-top: 1px solid #e5e7eb;\r\n  background: #fff;\r\n}\r\n\r\n.live-inbox-chat-input-wrap .live-inbox-chat-input {\r\n  border-top: none;\r\n}\r\n\r\n.live-inbox-assist-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px 14px;\r\n  padding: 8px 12px;\r\n  background: #fafafa;\r\n  border-bottom: 1px solid #eef0f3;\r\n  font-size: 12px;\r\n}\r\n\r\n.live-inbox-assist-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.live-inbox-assist-group-end {\r\n  margin-left: auto;\r\n}\r\n\r\n.live-inbox-assist-label {\r\n  color: #6b7280;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-inbox-assist-select {\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  padding: 4px 8px;\r\n  font-size: 12px;\r\n  color: #111827;\r\n  cursor: pointer;\r\n  outline: none;\r\n  max-width: 160px;\r\n}\r\n\r\n.live-inbox-assist-select:hover {\r\n  border-color: #a8abb2;\r\n}\r\n\r\n.live-inbox-assist-select:focus {\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 2px rgba(86, 22, 234, 0.15);\r\n}\r\n\r\n.live-inbox-assist-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  border: 1px solid #5616ea;\r\n  background: linear-gradient(135deg, #5616ea 0%, #7b3ff5 100%);\r\n  color: #fff;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  padding: 5px 12px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: transform 0.1s ease, box-shadow 0.2s ease, opacity 0.2s ease;\r\n}\r\n\r\n.live-inbox-assist-btn:hover:not(:disabled) {\r\n  box-shadow: 0 2px 6px rgba(86, 22, 234, 0.35);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-inbox-assist-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.live-inbox-assist-credits {\r\n  font-size: 11px;\r\n  color: #6b7280;\r\n  padding: 3px 8px;\r\n  border-radius: 10px;\r\n  background: #f3f4f6;\r\n  white-space: nowrap;\r\n}\r\n\r\n.live-inbox-assist-credits.is-exhausted {\r\n  background: #fee2e2;\r\n  color: #b91c1c;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Per-message translate row (hyperlink + flag/code select beneath bubble). */\r\n.message-translate-row {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-top: 4px;\r\n  padding-left: 2px;\r\n  font-size: 11px;\r\n  line-height: 1;\r\n}\r\n\r\n.message-translate-link {\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  font-size: 11px;\r\n  color: #5616ea;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.message-translate-link:hover:not(:disabled) {\r\n  color: #4a14d6;\r\n  text-decoration-thickness: 1.5px;\r\n}\r\n\r\n.message-translate-link:disabled {\r\n  color: #9ca3af;\r\n  cursor: default;\r\n  text-decoration: none;\r\n}\r\n\r\n.message-lang-picker {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.message-lang-trigger {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  border-radius: 4px;\r\n  padding: 1px 5px;\r\n  height: 20px;\r\n  font-size: 11px;\r\n  line-height: 1;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n}\r\n\r\n.message-lang-trigger:hover:not(:disabled) {\r\n  border-color: #c0c4cb;\r\n  background: #fafafa;\r\n}\r\n\r\n.message-lang-trigger:focus {\r\n  outline: none;\r\n  border-color: #5616ea;\r\n  box-shadow: 0 0 0 2px rgba(86, 22, 234, 0.12);\r\n}\r\n\r\n.message-lang-trigger:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n.message-lang-flag {\r\n  display: block;\r\n  width: 16px;\r\n  height: auto;\r\n  border-radius: 1px;\r\n  object-fit: cover;\r\n  box-shadow: 0 0 0 0.5px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.message-lang-code {\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.3px;\r\n  font-size: 10px;\r\n  color: #4b5563;\r\n}\r\n\r\n.message-lang-caret {\r\n  font-size: 9px;\r\n  color: #9ca3af;\r\n}\r\n\r\n.message-lang-menu {\r\n  /* Positioning is set inline by the portal-based MessageLangMenu component\r\n     (position: fixed + computed top/left/width/maxHeight) so the menu can\r\n     never be clipped by the chat scroll container or expand the chat\r\n     window. The styles below only cover appearance + scroll behaviour. */\r\n  z-index: 1000;\r\n  width: max-content;\r\n  min-width: 160px;\r\n  max-width: min(240px, calc(100vw - 16px));\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\r\n  padding: 4px;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.message-lang-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  border: none;\r\n  background: transparent;\r\n  padding: 5px 8px;\r\n  font-size: 12px;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  text-align: left;\r\n  font-family: inherit;\r\n}\r\n\r\n.message-lang-option:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.message-lang-option.is-active {\r\n  background: #eef0fb;\r\n  color: #5616ea;\r\n  font-weight: 600;\r\n}\r\n\r\n.message-lang-option .message-lang-flag {\r\n  width: 18px;\r\n}\r\n\r\n.message-lang-option .message-lang-code {\r\n  min-width: 22px;\r\n}\r\n\r\n.message-lang-name {\r\n  font-size: 12px;\r\n  color: inherit;\r\n  flex: 1;\r\n}\r\n\r\n.message-translate-spinner {\r\n  font-size: 10px;\r\n  color: #5616ea;\r\n}\r\n\r\n/* Translated text shown under the visitor's message bubble. */\r\n.message-translation {\r\n  margin-top: 6px;\r\n  padding: 6px 10px;\r\n  background: #f9fafb;\r\n  border: 1px solid #eef0f3;\r\n  border-left: 3px solid #5616ea;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  color: #4b5563;\r\n  font-style: italic;\r\n  max-width: 80%;\r\n  align-self: flex-end;\r\n}\r\n\r\n.message-translation-label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  color: #6b7280;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.3px;\r\n  margin-bottom: 2px;\r\n  font-style: normal;\r\n}\r\n\r\n.message-translation-text {\r\n  font-style: italic;\r\n  line-height: 1.45;\r\n}\r\n\r\n.message-translation-text p {\r\n  margin: 2px 0;\r\n}\r\n\r\n.message-translation-error {\r\n  color: #b91c1c;\r\n  font-style: italic;\r\n  font-size: 12px;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .live-inbox-assist-toolbar {\r\n    gap: 6px 10px;\r\n    padding: 6px 10px;\r\n  }\r\n  .live-inbox-assist-select {\r\n    max-width: 120px;\r\n  }\r\n  .live-inbox-assist-group-end {\r\n    margin-left: 0;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n}\r\n\r\n\r\n/* ---------------------------------------------------------------\r\n   Inline action buttons (suggest reply + translate input)\r\n   placed left of the send button inside .live-inbox-chat-input\r\n   --------------------------------------------------------------- */\r\n.live-inbox-chat-input-textwrap {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: stretch;\r\n}\r\n\r\n.live-inbox-chat-input-textwrap > textarea {\r\n  flex: 1;\r\n  width: 100%;\r\n}\r\n\r\n.live-inbox-input-busy-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 0 12px;\r\n  border-radius: 8px;\r\n  background: #f5f5f5;\r\n  border: 1px solid #ccc;\r\n  pointer-events: auto;\r\n  z-index: 2;\r\n}\r\n\r\n.live-inbox-input-busy-spinner {\r\n  color: #5616ea;\r\n  font-size: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.live-inbox-input-busy-label {\r\n  flex: 1;\r\n  min-width: 0;\r\n  font-size: 14px;\r\n  color: #4b5563;\r\n  font-style: italic;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.live-inbox-input-busy-cancel {\r\n  flex-shrink: 0;\r\n  border: 1px solid #d1d5db;\r\n  background: #fff;\r\n  color: #4b5563;\r\n  border-radius: 6px;\r\n  padding: 4px 10px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.live-inbox-input-busy-cancel:hover {\r\n  background: #fef2f2;\r\n  border-color: #fecaca;\r\n  color: #b91c1c;\r\n}\r\n\r\n.live-inbox-input-action-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  height: 34px;\r\n  padding: 0 10px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e5e7eb;\r\n  background: #fff;\r\n  color: #5616ea;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n  white-space: nowrap;\r\n  font-family: inherit;\r\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;\r\n}\r\n\r\n.live-inbox-input-action-btn svg {\r\n  font-size: 15px;\r\n}\r\n\r\n.live-inbox-input-action-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.1px;\r\n}\r\n\r\n.live-inbox-input-action-btn:hover:not(:disabled) {\r\n  background: #f3f0ff;\r\n  border-color: #d4c8fb;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.live-inbox-input-action-btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n  color: #9ca3af;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .live-inbox-input-action-label {\r\n    display: none;\r\n  }\r\n  .live-inbox-input-action-btn {\r\n    width: 34px;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.live-inbox-input-translate {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.live-inbox-input-translate-menu {\r\n  position: absolute;\r\n  bottom: calc(100% + 6px);\r\n  right: 0;\r\n  z-index: 50;\r\n  width: max-content;\r\n  min-width: 170px;\r\n  max-width: min(220px, calc(100vw - 32px));\r\n  max-height: 220px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background: #fff;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\r\n  padding: 4px;\r\n  overscroll-behavior: contain;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
